<template>
  <div
    v-if="sponsors?.length"
    :class="$style.root"
  >
    <div :class="$style.label">
      {{$t('shared.sponsors')}}
    </div>
    <SharedSponsorsComponent :sponsors="sponsors" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
    sponsors: array
  }>()
</script>

<style module>
.root {
  --block--margin-top: calc(var(--unit--vertical) * 2);
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

.label {
  composes: label font-size-small font-helvetica from global;
}
</style>
